var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersSubsidiaries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12 11H14V13H12V15H14V17H12V19H20V9H12V11ZM16 11H18V13H16V11ZM16 15H18V17H16V15Z",
    fill: "#49e2b5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15H18V17H16V15ZM16 11H18V13H16V11ZM22 7H12V3H2V21H22V7ZM6 19H4V17H6V19ZM6 15H4V13H6V15ZM6 11H4V9H6V11ZM6 7H4V5H6V7ZM10 19H8V17H10V19ZM10 15H8V13H10V15ZM10 11H8V9H10V11ZM10 7H8V5H10V7ZM20 19H12V17H14V15H12V13H14V11H12V9H20V19Z",
    fill: "#49e2b5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersSubsidiaries);
export default __webpack_public_path__ + "static/media/users-subsidiaries.6c63f0ce.svg";
export { ForwardRef as ReactComponent };